const state = {
    tsDetail:{},
  }
  
  const getters = {
    s_tsDetail(state) {
      return state.tsDetail
    },
  }
  
  const mutations = {
    
    SET_TSDETAIL: (state, tsDetail) => {
      state.tsDetail = tsDetail
    },
  }
  
  const actions = {
    setTsDetail({commit}, tsDetail) {
      commit('SET_TSDETAIL', tsDetail)
    },
   
  }
  
  
  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  }
  